"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Header;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
// @ts-ignore
var primitives_1 = require("web/components/primitives");
// @ts-ignore
var LL_Logo_Light_png_1 = __importDefault(require("assets/images/global/LL-Logo-Light.png"));
var styles_scss_1 = __importDefault(require("./styles.scss"));
function Header(_a) {
    var children = _a.children;
    var location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(function () {
        var _a = window.clientConfig, communitiesRequiringMasterServiceAgreements = _a.communitiesRequiringMasterServiceAgreements, tenantForTerms = _a.tenantForTerms;
        var termsPath = "/".concat(tenantForTerms, "/terms");
        var termsForMSAPath = "/".concat(tenantForTerms, "/accept-msa");
        if (tenantForTerms &&
            (communitiesRequiringMasterServiceAgreements === null || communitiesRequiringMasterServiceAgreements === void 0 ? void 0 : communitiesRequiringMasterServiceAgreements.length) &&
            location.pathname !== termsForMSAPath) {
            window.location.replace(termsForMSAPath);
        }
        else if (!(communitiesRequiringMasterServiceAgreements === null || communitiesRequiringMasterServiceAgreements === void 0 ? void 0 : communitiesRequiringMasterServiceAgreements.length) &&
            tenantForTerms &&
            location.pathname !== termsPath) {
            window.location.replace(termsPath);
        }
    }, [location.pathname]);
    (0, react_1.useEffect)(function () {
        var _a = window.clientConfig, communitiesRequiringMasterServiceAgreements = _a.communitiesRequiringMasterServiceAgreements, tenantForTerms = _a.tenantForTerms;
        var termsForMSAPath = "/".concat(tenantForTerms, "/accept-msa");
        if (tenantForTerms &&
            (communitiesRequiringMasterServiceAgreements === null || communitiesRequiringMasterServiceAgreements === void 0 ? void 0 : communitiesRequiringMasterServiceAgreements.length) &&
            location.pathname !== termsForMSAPath) {
            window.location.replace(termsForMSAPath);
        }
    }, [location.pathname]);
    return (react_1.default.createElement(primitives_1.FlexContainer, { flexDirection: "column", className: styles_scss_1.default.container },
        react_1.default.createElement(primitives_1.FlexContainer, { alignItems: "center", justifyContent: "spaceBetween", className: styles_scss_1.default.header },
            react_1.default.createElement(react_router_dom_1.Link, { to: "/login", className: styles_scss_1.default.logoLink },
                react_1.default.createElement("img", { src: LL_Logo_Light_png_1.default, className: styles_scss_1.default.logo, alt: "LifeLoop" })),
            react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://lifeloop.com/support" },
                react_1.default.createElement(primitives_1.Icon, { type: primitives_1.IconType.helpCircle, className: styles_scss_1.default.helpIcon, size: 26 }))),
        react_1.default.createElement(primitives_1.FlexContainer, { flex: "1", alignItems: "center", justifyContent: "center", className: styles_scss_1.default.childContainer },
            react_1.default.createElement(react_router_dom_1.Switch, null, children))));
}
